const EMPTY_PATTERN = {
  frontPath: '',
  backPath: '',
  fCreasePath: '',
  bCreasePath: '',
  dartPath: '',
  frontMeasurements: [],
  backMeasurements: [],
  constructionLines: [],
  grandTotalCrotch: null,
};

export function createPlannedGarmentPattern(garmentType, message) {
  return {
    ...EMPTY_PATTERN,
    draftingStatus: 'planned',
    garmentType,
    message,
  };
}
